import { DonationFromStatusTypeEnum } from '../../enum/donation-from-status-type.enum';

export class ExternalCsrCampaignDonationModel {
  name: string = null;
  email: string = null;
  phone: string = null;
  pledged_amount: number = null;
  comment: string = null;
  transaction_fees: number = null;
  is_featured_donation: boolean = null;
  is_video_call_active: boolean = null;
  whatsapp_no: string = null;
  user_id: string = null;
  is_hidden_name: boolean = null;
  is_direct_donation: boolean = null;
  is_hidden_comment: boolean = null;
  can_contact: boolean = null;
  is_hidden_name_and_amount: boolean = null;
  payment_receipt: string = null;
  ngo_id: string = null;
  employee_id: string = null;
  ngo_name: string = null;
  company_id: string = null;
  company_name: string = null;
  campaign_id: string = null;
  campaign_title: string = null;
  fundraiser_id: string = null;
  project_id: string = null;
  team_id: string = null;
  donation_from: DonationFromStatusTypeEnum =
    DonationFromStatusTypeEnum.DONATION;
  matching_request: string = null;
  ngo_campaign_id: string = null;
  is_anonymous: boolean = false;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}

export class ExternalCsrNgoDonatoinModel {
  name: string = null;
  email: string = null;
  phone: string = null;
  pledged_amount: number = null;
  comment: string = null;
  transaction_fees: number = null;
  is_featured_donation: boolean = null;
  is_video_call_active: boolean = null;
  whatsapp_no: string = null;
  user_id: string = null;
  is_hidden_name: boolean = null;
  is_direct_donation: boolean = null;
  is_hidden_comment: boolean = null;
  can_contact: boolean = null;
  is_hidden_name_and_amount: boolean = null;
  payment_receipt: string = null;
  ngo_id: string = null;
  employee_id: string = null;
  ngo_name: string = null;
  company_id: string = null;
  company_name: string = null;
  donation_from: string = null;
  matching_percentage: string = null;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}

export class MatchingRequestConfirmModel {
  request_status: 'APPROVED' | 'DENIED' = null;
  matching_percentage: number = null;
  matching_limit: number = null;
  matching_budget: number = null;
  end_date: Date = null;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}

export class PledgingSubmissionModel {
  pledging_status: string = null;
  payment_receipt: File | null = null;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}
